export { default } from './ShieldOutline'
